import { Grid } from "@mui/material";
import { useEffect, useState } from "react";
import Input from "../../../components/input/Input-v2";
import { LoadingButton } from "../../../components/button/Button";
import {
  useAddCategory,
  useGetCategoryDetail,
  useUpdateCategory,
} from "../../produk/api/product/category/resolver";

interface IForm {
  idBrand?: string;
}

export default function Form({ idBrand }: IForm) {
  const [brand, setBrand] = useState<undefined | string>("");
  const { mutate: mutateAdd, isLoading: loadingAdd } = useAddCategory({
    redirect: true,
  });
  const { mutate: mutateUpdate, isLoading: loadingUpdate } =
    useUpdateCategory();
  const { data: dataRawBrand, isLoading: fetchBrand } = useGetCategoryDetail({
    product_category_id: idBrand,
  });
  const [error, setError] = useState<string>("");
  const loading = loadingAdd || loadingUpdate;

  useEffect(() => {
    if (idBrand && dataRawBrand) {
      setBrand(dataRawBrand.data.data.category_name);
    }
  }, [idBrand, dataRawBrand]);

  const handleAdd = () => {
    if (brand === undefined) {
      setError("Kolom ini wajib di isi");
      return;
    }
    setError("");
    if (idBrand) {
      mutateUpdate({ category_name: brand, product_category_id: idBrand });
    } else {
      mutateAdd({ category_name: brand });
    }
  };

  return (
    <Grid container>
      <Grid item xs={12} md={12}>
        <Input.Text
          isFetching={fetchBrand}
          label="Nama Kategori"
          onChange={(e) => setBrand(e)}
          value={brand}
          error={error}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={12}
        display={"flex"}
        justifyContent={"flex-end"}
        mt={2}
      >
        <LoadingButton
          text={idBrand ? "Update" : "Submit"}
          isLoading={loading}
          onClick={handleAdd}
        />
      </Grid>
    </Grid>
  );
}
